import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export default function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      settings: {
        general_settings: {
          well_known_links: {
            form: {
              header: 'FORM.HEADER',
              package_name: 'FORM.PACKAGE_NAME',
              sha256_cert_fingerprints: 'FORM.CERT_FINGERPRINTS',
              domains: 'FORM.DOMAINS',
              submit: 'FORM.SUBMIT',
            },
            update: {
              title: 'UPDATE.TITLE',
              save: 'UPDATE.SUBMIT',
            },
            table: {
              header: 'TABLE.HEADER',
            },
          },
        },
      },
    },
  }));
}
